// App.js
import React, { useEffect } from 'react';
import { ThemeProvider, CssBaseline, Box } from '@mui/material';
import { theme } from './theme';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Routes from './Routes';
import Footer from './components/Footer';
import { initGA, pageView } from './utils/analytics';
import { Analytics } from "@vercel/analytics/react";

const AppContent = () => {
  const location = useLocation();

  useEffect(() => {
    try { initGA(); } catch (e) { console.error('GA init failed:', e); }
  }, []);

  useEffect(() => {
    try { pageView(location.pathname); } catch (e) { console.error('GA pageView failed:', e); }
  }, [location]);

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', bgcolor: 'background.default' }}>
      <Navbar />
      <Box sx={{ flex: 1 }}>
        <Routes />
      </Box>
      <Footer />
    </Box>
  );
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AppContent />
        <Analytics />
      </Router>
    </ThemeProvider>
  );
}

export default App;
